/*export function getGuidedTours() {
    return function(dispatch){
        //https://api.myjson.com/bins/dtrmg
        //http://staging-app4.gmailsharedcontacts.com/api/guidedTours/101466981364550601109
        axios.get(API_ROOT + '/api/guidedTours', {withCredentials: true}).then( response => {
            dispatch({
                type: "GET_GUIDED_TOURS",
                payload: response.data
            })
        })
    }
}*/

/*export function postGuidedTours(object) {
    return function(dispatch){
        axios.put(API_ROOT + '/api/guidedTours', object, {withCredentials: true}).then(() => {
            dispatch(getGuidedTours());
        });
    }
}*/

export function guidedTours(object){
    return function(dispatch){
        dispatch({
            type: "GUIDED_TOURS",
            payload: object
        })
    }
}